import { render } from "./IconCube.vue?vue&type=template&id=756f8549"
import script from "./IconCube.vue?vue&type=script&lang=js"
export * from "./IconCube.vue?vue&type=script&lang=js"
script.render = render

export default script